import MonitoringReviewActions from './review-actions'

export const VendorIdentity = ({ name, externalId, status }) => (
  <div style={{ minWidth: 0 }}>
    <div className={`monitoring-match-name${name ? '' : ' is-empty'}`}>
      {name || 'Unknown vendor'}
    </div>
    {(externalId || status) && (
      <div className="monitoring-match-meta">
        {externalId && <span style={{ fontVariantNumeric: 'tabular-nums' }}>#{externalId}</span>}
        {externalId && status && <span aria-hidden="true"> · </span>}
        {status && <span>{status}</span>}
      </div>
    )}
  </div>
)

// Styling comes from MONITORING_STYLES, which the monitoring page injects once.
const FindingCard = ({ transaction, eyebrow, onOpen, children }) => {
  const analytics = transaction.analytics || []
  const review = transaction.review
  const reviewStatus = review?.status
  const isDecided = ['Resolved', 'Ignored', 'Excluded'].includes(reviewStatus)

  return (
    <div
      className={`monitoring-card p-3 mb-2${isDecided ? ' is-resolved' : ''}`}
      role="button"
      tabIndex={0}
      onClick={onOpen}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onOpen()
        }
      }}
    >
      <div
        className="d-flex justify-content-between align-items-center pb-2 mb-2"
        style={{
          borderBottom: '1px dashed #e2e8f0',
          marginLeft: '-1rem',
          marginRight: '-1rem',
          paddingLeft: '1rem',
          paddingRight: '1rem'
        }}
      >
        <div className="monitoring-eyebrow d-flex align-items-center gap-3">
          <span>
            <span aria-hidden="true">⚑</span>&nbsp;{eyebrow}
          </span>
          {isDecided && (
            <span style={{ fontWeight: 500, textTransform: 'none', letterSpacing: 0, color: '#495057' }}>
              {reviewStatus}
              {review?.reason ? ` · ${review.reason}` : ''}
            </span>
          )}
        </div>
        <MonitoringReviewActions
          transactionId={transaction.id}
          review={review}
          compact
          sectionId={transaction.section_id}
          sectionAbbreviation={transaction.section_abbreviation}
          vendorId={transaction.vendor_id}
          vendorName={transaction.vendor_name}
          employeeId={transaction.employee_id}
          employeeName={transaction.employee_full_name}
          controlAnalytics={analytics.map((entry) => ({ id: entry.id, name: entry.name }))}
        />
      </div>

      {children}
    </div>
  )
}

// Skips the finding the eyebrow already names.
export const OtherAnalytics = ({ analytics, exceptIds }) => {
  const others = (analytics || []).filter((entry) => !exceptIds.includes(entry.id))
  if (others.length === 0) return null

  return others.map((entry) => (
    <span
      key={entry.id}
      className={`monitoring-pill weight-${entry.weight || 'low'}${entry.is_excluded ? ' is-excluded' : ''}`}
    >
      {entry.name}
    </span>
  ))
}

export default FindingCard
